import { FC, useCallback } from 'react';

import { Badge, Card, Label } from 'reactstrap';

import { ActionLabel, ActionsDropdown, FontAwesomeIcon } from '@hsp/react-component-library';
import { isDefined } from '@hsp/utilities';

import { IUserInfo } from '@t/user/components/user-info/user-profile.model';

import cssClasses from './body.module.scss';

const ProfileInfo: FC<IUserInfo> = ({ item }) => {
  const trimName = useCallback((firstName?: string, lastName?: string) => {
    if (isDefined(firstName) && isDefined(lastName)) {
      const firstInitial = firstName.slice(0, 1);
      const lastInitial = lastName.slice(0, 1);

      return firstInitial?.concat(lastInitial);
    }
  }, []);

  return (
    <>
      <div>
        <Card className={cssClasses.userCard}>
          <div className="d-flex  justify-content-start gap-4">
            <div>
              <div className={cssClasses.image}>
                <span className="text-light">{trimName(item?.firstName, item?.lastName)}</span>
              </div>
            </div>

            <div className="flex-fill ms-4">
              <span className={cssClasses.userName}>{item?.firstName + ' ' + item?.lastName}</span>
              <div className="mt-3">
                <div className="d-flex justify-content-between">
                  <div>
                    <FontAwesomeIcon icon={'envelope'} />
                    <span className="ms-2">{item?.email}</span>
                  </div>
                  <div>
                    <FontAwesomeIcon icon={['fas', 'phone']} />
                    <span className="ms-2">{item?.phoneNumber}</span>
                  </div>
                  <div>
                    <ActionsDropdown>
                      <ActionLabel>Actions</ActionLabel>
                    </ActionsDropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex border-top border-black mt-3 justify-content-between">
            <div className=" d-flex flex-column ">
              <Label>Reporter</Label>
              <span>{item?.reporter}</span>
            </div>
            <div className="d-flex flex-column">
              <Label>Department</Label>
              <span>{item?.department}</span>
            </div>
            <div className="d-flex flex-column">
              <Label>Role</Label>
              <span>{item?.role}</span>
            </div>
            <div className="d-flex flex-column">
              <Label>Client Group</Label>
              <span>{item?.clientGroup}</span>
            </div>
          </div>
        </Card>
      </div>
      <div>
        <div className="d-flex">
          <h4>Upcoming</h4>
          <Badge color="secondary">4</Badge>
        </div>
      </div>
    </>
  );
};

export default ProfileInfo;
